import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
// TODO: Import required services for Foreign Keys
import { PileTypeService } from '../proxy/planning/controllers/pile-type.service';
import { PileStatusService } from '../proxy/planning/controllers/pile-status.service';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { LogyardService } from '../proxy/planning/controllers/logyard.service';
import { FinalProductService } from '@general/proxy/general/controllers/final-product.service';
import { ContractTypeGroupService } from '@controlling/proxy/controlling/controllers/contract-type-group.service';
import { GeneticMaterialTypeService } from '@general/proxy/general/controllers/genetic-material-type.service';

import { PileDetail } from '../pile-detail/pile-detail';
FieldBuilder.setNamespace('Planning');

export const PILE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Pile.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .number('number', 'Entity.Pile.Number')
    .required()
    .build(),
  FieldBuilder
    .checkbox('isPefcCertified', 'Entity.Pile.IsPefcCertified')
    .build(),
  FieldBuilder
    .datetime('inactivationDate', 'Entity.Pile.InactivationDate')
    .build(),
  FieldBuilder
    .number('woodAge', 'Entity.Pile.WoodAge')
    .decimal(2,9)
    .build(),
  FieldBuilder
    .number('finalLogyardWoodAge', 'Entity.Pile.FinalLogyardWoodAge')
    .decimal(2,9)
    .build(),
  FieldBuilder
    .foreignKey('pileTypeId', 'Entity.PileType', PileTypeService)
    .required()
    .displayFromNested('pileType.name')
    .sortBy('pileType.name')
    .build(),
  FieldBuilder
    .foreignKey('pileStatusId', 'Entity.PileStatus', PileStatusService)
    .required()
    .displayFromNested('pileStatus.name')
    .sortBy('pileStatus.name')
    .build(),
  FieldBuilder
    .foreignKey('logyardId', 'Entity.Logyard', LogyardService)
    .required()
    .displayFromNested('logyard.name')
    .sortBy('logyard.name')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('finalProductId', 'Entity.Pile.FinalProduct', FinalProductService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('contractTypeGroupId', 'Entity.Pile.ContractTypeGroup', ContractTypeGroupService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('geneticMaterialTypeId', 'Entity.Pile.GeneticMaterialType', GeneticMaterialTypeService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const PILE_CONFIG = {
  entityName: 'Pile',
  localizationKey: 'Planning::Entity.Pile',
  fields: PILE_FIELDS,
  permission: 'PlanningLocation.Piles',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'PileDetail',
      foreignKeyField: 'pileId',
      localizationKey: 'Planning::Entity.PileDetail',
      component: PileDetail,
    },
  ],
};
